import { PrismicNextLink } from "@prismicio/next/pages";

import { linkResolver } from "@up/data";

import type { PrismicNextLinkProps } from "@prismicio/next/pages";

export const UPLink = function UPLink(props: PrismicNextLinkProps) {
  return <PrismicNextLink linkResolver={linkResolver} {...props} />;
};
